import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useSearchParams } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ApiProvider } from './context/ApiContext';
import { DesignProvider } from './context/DesignContext';
import { ToastProvider, useToast } from './components/ui/Toast';
import { AppRoutes } from './routes/AppRoutes';
import { SharedPage } from './pages/SharedPage';

const AppContent = () => {
    const { addToast } = useToast();
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        if (searchParams.get('success')) {
            addToast("Payment Successful! Credits have been added to your account.", 'success');
            setSearchParams((params) => {
              params.delete('success');
              return params;
            });
        }
    }, [searchParams, addToast, setSearchParams]);

    // Simple routing for shared items outside the main router logic if needed,
    // or just let AppRoutes handle it if we integrated it.
    // Since existing logic used query params 'share' and 'type' on the root URL,
    // we intercept it here.
    if (searchParams.get('share')) {
        return <SharedPage />;
    }
    
    return <AppRoutes />;
};

function App() {
  return (
    <ToastProvider>
      <AuthProvider>
        <ApiProvider>
          <DesignProvider>
            <BrowserRouter>
               <AppContent />
            </BrowserRouter>
          </DesignProvider>
        </ApiProvider>
      </AuthProvider>
    </ToastProvider>
  );
}

export default App;
